"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TooltipHOC = _interopRequireDefault(require("../../../../shared/components/TooltipHOC/TooltipHOC"));

var _CustomReactMarkdown = _interopRequireDefault(require("../../../../shared/components/MarkdownRenderers/CustomReactMarkdown"));

var _iconCaret = _interopRequireDefault(require("../../../../shared/icons/icon-caret.svg"));

var _iconChevron = _interopRequireDefault(require("../../../../shared/icons/icon-chevron.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NavigationFlyout = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationFlyout, _React$Component);

  var _super = _createSuper(NavigationFlyout);

  function NavigationFlyout(props) {
    var _this;

    _classCallCheck(this, NavigationFlyout);

    _this = _super.call(this, props);
    props.setConfig({
      alignMsg: 'left',
      title: 'Navigation',
      iconDimensions: 0,
      expandOnFocus: false
    });
    return _this;
  }

  _createClass(NavigationFlyout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$navItem = _this$props.navItem,
          name = _this$props$navItem.name,
          subGroups = _this$props$navItem.subGroups,
          renderMsgBlock = _this$props.renderMsgBlock;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "navigation-flyout__trigger"
      }, name, /*#__PURE__*/_react["default"].createElement(_iconChevron["default"], {
        className: "navigation-flyout__chevron"
      })), renderMsgBlock( /*#__PURE__*/_react["default"].createElement("span", {
        className: "navigation-flyout"
      }, /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
        className: "navigation-flyout__caret"
      }), subGroups.map(function (subGroup) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "navigation-flyout__subgroup",
          key: subGroup.name
        }, subGroup.name && /*#__PURE__*/_react["default"].createElement("span", {
          className: "navigation-flyout__subgroup-title"
        }, subGroup.name), /*#__PURE__*/_react["default"].createElement("ul", {
          className: "navigation-flyout__link-list"
        }, subGroup.items.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            className: "navigation-flyout__link",
            key: item
          }, /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
            key: item,
            source: item,
            noWrapper: true
          }));
        })));
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "navigation-flyout__accent"
      }))));
    }
  }]);

  return NavigationFlyout;
}(_react["default"].Component);

NavigationFlyout.propTypes = {
  navItem: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    subGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  renderMsgBlock: _propTypes["default"].func.isRequired,
  setConfig: _propTypes["default"].func.isRequired
};

var _default = (0, _TooltipHOC["default"])(NavigationFlyout);

exports["default"] = _default;